/** Statuses where the first logged inbound reply should advance workflow to `replied`. */
export const FUNDING_OUTREACH_STATUSES_BEFORE_REPLIED = ["to_contact", "pending_send", "contacted"] as const;

export function fundingOutreachShouldAdvanceToReplied(currentStatus: string | null | undefined): boolean {
  if (currentStatus == null) return false;
  return (FUNDING_OUTREACH_STATUSES_BEFORE_REPLIED as readonly string[]).includes(currentStatus);
}
